import { BaseData } from 'src/app/shared/models/base-data';

export class AccountHoldingsData extends BaseData {

}

export class BuyingPowerReq {
    AccountNumber: string;
}